module.exports = __webpack_public_path__ + "img/safari_121.10e0cab1.png";